import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DataCollectionService } from './DataCollection.service';

@NgModule({
    imports: [CommonModule],
    providers: [DataCollectionService]
})
export class DataCollectionModule {}
